export default {
	install(Vue) {
		window.eventBus = new Vue();

		Vue.mixin({
			methods: {
				httpError(component, payload) {
					window.eventBus.$emit('error-page', component, payload);
				}
			}
		});
	}
};
